import React from "react";
import HeroCarouselSettings from "../home/HeroCarouselSettings";
import { SERVICE_ICONS } from "../../data/serviceIcons";

// The Co-Work banner slider: same fields as the Home banner, stored as CoWorkSlide rows. Its icons are
// not developer tools but the services sellers offer on the marketplace.
export default function CoWorkSlidesSettings() {
  return (
    <HeroCarouselSettings
      endpoint="/core/cowork/slides/"
      heading="Banner Slides"
      itemLabel="Slide"
      addLabel="Add Slide"
      deleteWarning="Delete this slide from the Co-Work banner?"
      iconSet={SERVICE_ICONS}
      iconHint="Seller services to feature"
      intro="The slides of the Co-Work page banner. Each slide has an image, a title, a description and the seller services to feature (Web Development, Graphic Designing, Resume Writing, Blog Posting, ...), shown as icons under the description. The 'Post a Job' and 'Find Work' buttons are added under every slide (their text is under Marketplace Content)."
    />
  );
}
